import Icon from '../components/Icon.vue'

Icon.register({
  satellite: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.7 265L422.4 184.6 470.2 136.7C483.3 123.6 483.3 102.3 470.2 89.2L422.7 41.7C409.6 28.6 388.3 28.6 375.2 41.7L327.4 89.6 247.1 9.3C240.8 3.1 232.7 0 224.5 0S208.2 3.1 202 9.3L105.3 106C92.9 118.4 92.9 138.6 105.3 151.1L185.6 231.5 175.8 241.3C122.1 217 59.6 218.6 7.3 246.7-1.2 251.3-2.3 263.1 4.5 269.9L112 377.4 94.2 395.2C91.6 394.5 89.2 393.6 86.4 393.6 68.7 393.6 54.4 407.9 54.4 425.6S68.7 457.6 86.4 457.6 118.4 443.3 118.4 425.6C118.4 422.8 117.5 420.4 116.8 417.8L134.6 400 242.1 507.5C248.9 514.3 260.8 513.2 265.3 504.7 293.4 452.4 295 389.9 270.7 336.2L280.6 326.3 360.9 406.7C367.1 412.9 375.3 416 383.4 416S399.7 412.9 405.9 406.7L502.6 310C515.1 297.6 515.1 277.4 502.7 265zM150.7 128.5L224.5 54.7 293.4 123.6 219.6 197.4 150.7 128.5zM383.5 361.3L314.6 292.4 388.4 218.6 457.3 287.5 383.5 361.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/satellite.js
// module id = CRB0
// module chunks = 144